import { useQuery } from "@tanstack/react-query";
import apiServices from "../ApiServices/request-handler";

const fetchProjectList = async ({ queryKey }) => {
  const [, currentPage] = queryKey;
  const response = await apiServices.getprojectStatus(currentPage);
  return response.data;
};

export const useProjectStatus = (currentPage) => {
  return useQuery({
    queryKey: ["projectStatus", currentPage], // ✅ fixed typo
    queryFn: fetchProjectList,
  });
};
